export default __webpack_public_path__ + "static/media/integration.95185390.png";